module.exports = "<div data-bind=\"click: itemClick, style: style, css:{'y-selected-item':active,'y-selected-multiItem':multiActive, 'y-select-hover':index() == curIndex()},\n  attr: {fieldid: fieldid}\n\" class=\"y-option\" >\n  <span data-bind=\"text:value[label],attr:{title:value[label]}\"></span>\n  <i data-bind=\"visible:multiActive\" class=\"fa fa-check pull-right\"></i>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/select/option.html
// module id = 478
// module chunks = 0